// Shared formatting + tokens for the Evidence Library surfaces
// (EvidenceLibrary list view and EvidenceAuditDetail drill-down).

export const STATUS_COLORS = {
    compliant: '#0f7b4f', partially_compliant: '#d97706',
    non_compliant: '#dc2626', not_applicable: '#8492a6',
    not_checked: '#8492a6', opportunity_for_improvement: '#1b2a4a',
};

export const CATEGORY_COLORS = {
    major: '#dc2626', minor: '#d97706', ofi: '#1b2a4a',
    observation: '#8492a6', compliant: '#0f7b4f',
};

export const fmtDate = (ts) => {
    if (!ts) return '-';
    try { return new Date(ts).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); }
    catch { return ts; }
};

export const fmtSize = (bytes) => {
    if (!bytes) return '-';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const prettyLabel = (value) => (value || '').replace(/_/g, ' ');

export const saveBlob = (blob, fileName) => {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const thStyle = (sortable) => ({
    padding: '8px 10px', textAlign: 'left', fontSize: 9, fontWeight: 700,
    color: 'var(--ap-text-3)', textTransform: 'uppercase', letterSpacing: 0.5,
    whiteSpace: 'nowrap', cursor: sortable ? 'pointer' : 'default',
});

export const tdStyle = { padding: '8px 10px', color: 'var(--ap-text-2)', verticalAlign: 'top' };

export const pillStyle = (color) => {
    const tone = color || '#8492a6';
    return {
        display: 'inline-block', padding: '2px 8px', fontSize: 9, fontWeight: 600,
        color: tone, background: `${tone}1f`, border: `1px solid ${tone}4d`,
        borderRadius: 3, textTransform: 'uppercase', letterSpacing: 0.3, whiteSpace: 'nowrap',
    };
};

export const tileStyle = {
    flex: '1 1 130px', padding: '10px 12px', borderRadius: 6,
    border: '1px solid var(--ap-border)', background: 'var(--ap-surface-2)',
};

export const tileLabelStyle = {
    fontSize: 9, fontWeight: 700, letterSpacing: 0.5,
    textTransform: 'uppercase', color: 'var(--ap-text-3)',
};

export const tileValueStyle = { fontSize: 20, fontWeight: 700, color: 'var(--ap-text)', marginTop: 2 };
